export const ROUTES = {
  // Auth
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  CHANGE_PASSWORD: "/change-password",

  // Dashboard
  DASHBOARD: "/",

  // Customers
  CUSTOMERS: "/customers",
  CUSTOMER_DETAIL: "/customers/:id",

  // Drivers
  DRIVERS: "/drivers",
  DRIVER_DETAIL: "/drivers/:id",
  DRIVER_KYC: "/drivers/:id/kyc",
  KYC_PENDING: "/drivers/kyc/pending",
  KYC_DETAIL: "/drivers/kyc/:id",

  // Vehicles
  VEHICLES: "/vehicles",
  VEHICLE_PENDING: "/vehicles/pending",
  VEHICLE_DETAIL: "/vehicles/:id",

  // Bookings
  BOOKINGS: "/bookings",
  BOOKING_DETAIL: "/bookings/:id",
  LIVE_TRACKING: "/bookings/:id/tracking",

  // Pricing
  PRICING: "/pricing",
  FARE_RULES: "/pricing/fare-rules",
  COMMISSION: "/pricing/commission",

  // Payments
  PAYMENTS: "/payments",
  PAYMENT_DETAIL: "/payments/:id",
  PAYOUTS: "/payments/payouts",
  DRIVER_EARNINGS: "/payments/earnings",

  // Support
  SUPPORT: "/support",
  TICKET_DETAIL: "/support/:id",

  // Reports
  REPORTS: "/reports",
  BOOKING_REPORTS: "/reports/bookings",
  REVENUE_REPORTS: "/reports/revenue",
  DRIVER_REPORTS: "/reports/drivers",
  GST_REPORT: "/reports/gst",

  // Fraud & Safety
  FRAUD: "/fraud",
  FRAUD_REPORTS: "/fraud/reports",
  UNBLOCK_REQUESTS: "/fraud/unblock-requests",
  FRAUD_INTELLIGENCE: "/fraud/intelligence",

  // Zipto Shield
  ZIPTO_SHIELD: "/zipto-shield",

  // Push Notifications
  PUSH_NOTIFICATIONS: "/push-notifications",

  // Settings
  SETTINGS: "/settings",
  PROFILE: "/settings/profile",

  // Coupons
  COUPONS: "/coupons",

  // Referrals
  REFERRALS: "/referrals",
} as const;

// Helper to build routes with params
export const buildRoute = (
  route: string,
  params: Record<string, string>,
): string => {
  let result = route;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
};
